<template>
  <ScrollTop />
  <ExposeMotifs
    :content="legiWorkZoom.expose_motifs"
    :occurrences="legiWorkZoom.expose_motifs_occurrences"
  />
</template>

<script setup>
import { storeToRefs } from "pinia";

import ExposeMotifs from "@follaw-fr/components/legi-work/templates/ExposeMotifs.vue";
import { useLegiWorkStore } from "@follaw-fr/stores/legi-work";
import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";

const store = useLegiWorkStore();

const { legiWorkZoom } = storeToRefs(store);
</script>
